import { FC } from 'react';
import { DateTime } from '../date-time';
import s from './datetime-range.module.css';
import { FaMinus } from 'react-icons/fa6';
import { isMobile } from '../../../helpers/devices';
import cn from 'classnames';

interface Props {
  onChangeFrom: (date?: Date) => void;
  onChangeTo: (date?: Date) => void;
  fromValue?: string;
  toValue?: string;
  name?: string;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
}

export const DateTimeRange: FC<Props> = (props) => {
  const { onChangeFrom, onChangeTo, minDate, maxDate, name, fromValue, toValue, disabled } = props;

  return (
    <div className={cn(s.feature, disabled && s.disabled)}>
      <DateTime
        onChange={onChangeFrom}
        minDate={minDate}
        maxDate={maxDate}
        name={name ? `${name}-from` : undefined}
        value={fromValue}
      />
      {!isMobile() && <FaMinus className={s.icon} />}
      <DateTime
        onChange={onChangeTo}
        minDate={minDate}
        maxDate={maxDate}
        name={name ? `${name}-to` : undefined}
        value={toValue}
      />
    </div>
  );
};
